document.querySelectorAll('[data-footer]').forEach((footer) => {
  if (footer.hasAttribute('data-ready')) return;
  footer.setAttribute('data-ready', '');
  const mobile = window.matchMedia('(max-width: 700px)');
  const groups = footer.querySelectorAll('.ss-footer-group');
  const syncMenus = () => groups.forEach((group) => {
    group.open = !mobile.matches;
    group.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
  });
  groups.forEach((group) => {
    group.querySelector('summary').addEventListener('click', (event) => {
      if (!mobile.matches) event.preventDefault();
    });
  });
  syncMenus();
  mobile.addEventListener('change', syncMenus);
});
